import { useMemo } from 'react'

import { MakeEmbroideredCartItemV2Input } from '../useMakeEmbroideredCartItemV2'

import { useEmbroideryGarment } from './EmbroideryGarmentProvider'
import { useEmbroideryPrices } from './EmbroideryPricingProvider'
import { useEmbroiderySelection } from './EmbroiderySelectionProvider'

/** What `useMakeEmbroideredCartItemV2` needs to build the bag lines, read from the new providers. */
export const useMakeEmbroideredCartItemV2Input = (): MakeEmbroideredCartItemV2Input => {
  const { itemsForBag } = useEmbroiderySelection()
  const { productColorHex } = useEmbroideryGarment()
  const { v2EmbroideryVariants: variants } = useEmbroideryPrices()

  return useMemo(
    () => ({ items: itemsForBag, variants, productColorHex }),
    [itemsForBag, variants, productColorHex]
  )
}
